import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class TrashIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="16" viewBox="0 0 14 16" width="14" xmlns="http://www.w3.org/2000/svg"><path d="M0 1h5V0h4v1h5v2H0V1zm1 3h12l-1.5 12h-9L1 4zm9.92 1H9.708L9 15h.924l.996-10zM7.65 5H6.4l.164 10h.953L7.65 5zM4.194 5H3l1.012 10h.91L4.195 5z" fillRule="evenodd"/></svg>
        )
    }
}

export default withCssClassName(TrashIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/trash-icon.js